import { useCallback, useState } from 'react';
import { useWatch } from 'react-hook-form';
import InputDecorator from '@enerex/unified-ui-react/form/InputDecorator';
import Select from 'components/UnifiedSelect';
import { commodityIcons, findCommodityIcon } from './commodityIcons';
import CommodityName from './CommodityName';

const CommodityIconField = ({ field, control, disabled }) => {
    const color = useWatch({ control, name: 'commodityColor' });
    const [portalTarget, setPortalTarget] = useState(null);
    const attach = useCallback(element => setPortalTarget(element?.closest('[role="dialog"]') ?? null), []);
    return <div ref={attach}>
        <InputDecorator name={field.name} control={control} label={field.label}
            render={({ field: input, fieldState }) => {
                const saved = findCommodityIcon(input.value);
                const current = input.value ? { value: input.value, label: saved?.label || `Saved icon: ${input.value}` } : null;
                return <Select inputId="commodity-icon" aria-label={field.label} name={input.name}
                    className="settings-lookup__form-select" ref={input.ref}
                    options={commodityIcons} value={current} isSearchable isClearable={false}
                    placeholder="Select commodity icon" isDisabled={disabled} invalid={fieldState.invalid}
                    menuPortalTarget={portalTarget} menuPosition="fixed"
                    onChange={option => {
                        if (!option) return;
                        input.onChange(option.value);
                    }} onBlur={input.onBlur}
                    formatOptionLabel={option => <CommodityName commodity={{ name: option.label,
                        commodityIcon: option.value, commodityColor: color }} />} />;
            }} />
    </div>;
};
export default CommodityIconField;
